<template>
  <div :class="contentWidth === 'boxed' ? 'container p-0' : null">
    <div class="horizontal-menu-wrapper home-menu-wrap">
      <!-- <div
        class="header-navbar navbar-expand-sm navbar navbar-horizontal navbar-light navbar-shadow menu-border d-xl-block"
      >
        <horizontal-nav-menu />
      </div> -->
      <b-navbar
        toggleable="sm"
        class="header-navbar navbar-shadow align-items-center navbar-brand-center navbar-fixed p-1"
      >
        <b-navbar-brand to="/">
          <img
            id="company-logo"
            class="img-logo-print"
            :src="require('@/assets/svg/maxlogo.png')"
            alt="Company Logo"
          >
        </b-navbar-brand>

        <b-navbar-toggle target="nav-collapse" />
        <b-collapse
          id="nav-collapse"
          class="justify-content-between  font-weight-bolder text-black home-nav"
          is-nav
        >
          <b-navbar-nav>
            <b-nav-item to="/">
              <span
                class="text-body-heading"
              >
                Home
              </span>
            </b-nav-item>
            <b-nav-item
              to="/channel-sms"
            >
              <span
                class="text-body-heading"
              >
                Channel
              </span>
            </b-nav-item>
            <b-nav-item to="/terms">
              <span
                class="text-body-heading"
              >
                Terms & Regulation
              </span>
            </b-nav-item>
            <b-nav-item
              to="/user-guideline/sign-up"
            >
              <span
                class="text-body-heading"
              >
                User Guidelines
              </span>
            </b-nav-item>
          </b-navbar-nav>
          <b-navbar-nav v-if="!$store.state.auth.userData">
            <b-nav-item
              to="/login"
              class="btn-login align-self-center m-0"
            >
              <span
                class="text-primary font-medium-1 btn-login"
              >
                Login
              </span>
            </b-nav-item>
            <b-nav-item
              to="/register"
              class="btn btn-primary btn-sm mr-2 btn-signup"
              link-classes="text-white font-weight-bolder font-medium-1"
            >Sign Up</b-nav-item>
          </b-navbar-nav>
          <b-navbar-nav v-if="$store.state.auth.userData">
            <b-nav-item
              class="btn-login align-self-center m-0 p-0 border-right border-right-2"
            >
              <span
                class="text-body-heading font-medium-1"
              >
                Hi, <span class="text-danger"> {{ $store.state.auth.userData.data.fullName }} </span>You are still login
              </span>
            </b-nav-item>
            <b-nav-item
              to="/dashboard"
              class="btn-login align-self-center m-0 p-0"
            >
              <span
                class="text-primary font-medium-1"
              >
                Go to Dashboard
              </span>
            </b-nav-item>
          </b-navbar-nav>
        </b-collapse>
      </b-navbar>
    </div>
    <router-view />
  </div>
</template>

<script>
import useAppConfig from '@core/app-config/useAppConfig'
import {
  BNavbar,
  BNavbarBrand,
  BNavbarToggle,
  BNavbarNav,
  BNavItem,
  BCollapse,
} from 'bootstrap-vue'
// import HorizontalNavMenu from './components/horizontal-nav-menu/HorizontalNavMenu.vue'

export default {
  components: {
    // HorizontalNavMenu,
    BNavbar,
    BNavbarBrand,
    BNavbarToggle,
    BNavbarNav,
    BNavItem,
    BCollapse,
  },
  setup() {
    const { contentWidth } = useAppConfig()
    return { contentWidth }
  },
}
</script>
